import { isMobile, isSafari } from 'react-device-detect';
import axios from 'axios';

const handleOpenReport = async (
  accountId, downloadUrl, patientName, setDownloadLaudoUrl,
  setLaudoOpen, setLoadingLaudo, setUrlLaudo, studyId, user
) => {
  setLoadingLaudo(true);

  const pdfBody = await axios
    .get(downloadUrl, { responseType: 'blob' })
    .then(res => res.data);
  const file = new Blob([pdfBody], { type: 'application/pdf' });

  axios.post('/external/insertResultsPortalLogs', {
    type: 'resultsPortal',
    subType: 'retrieveReport',
    studyId,
    patientName,
    accountId,
    user: {
      username: user.username,
      typeUser: user.type === 'medico'
        ? 'Médico solicitante'
        : user.type === 'paciente' ? 'Paciente' : 'Prestador'
    }
  }).then(() => {}).catch((err) => { console.error(err); });

  if(isMobile) {
    if(isSafari) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = () => {
        const element = document.createElement('a');
        element.href = window.URL.createObjectURL(file);
        element.download = 'laudo.pdf';
        element.click();

        setLaudoOpen(false);
        setLoadingLaudo(false);
      };
    } else {
      if (navigator.userAgent.includes('WA4A') || navigator.userAgent.includes('WAiOS')) {
        window.location.href = downloadUrl;
      } else {
        window.open(window.URL.createObjectURL(file), '_blank');
      }
      setLaudoOpen(false);
      setLoadingLaudo(false);
    }
  } else {
    setUrlLaudo(URL.createObjectURL(file));
    setDownloadLaudoUrl(downloadUrl);
    setLaudoOpen(true);
    setLoadingLaudo(false);
  }
};

export default handleOpenReport;